import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { PopupTextInputModal } from '../../../../../components/common/modal/popup/PopupTextInputModal';
import { SlideConfirmModal } from '../../../../../components/common/modal/slide/SlideConfirmModal';
import { SurveyForm } from '../../../../../components/common/survey/form/SurveyForm';
import { SurveyInputContainer } from '../../../../../components/common/survey/inputs/SurveyInputContainer';
import { SurveyInputHeader } from '../../../../../components/common/survey/inputs/SurveyInputHeader';
import { RadioCard } from '../../../../../components/common/Radio/RadioCard';
import { joinProcessConstants } from '../../../../../constants/joinProcess';
import { useAppDispatch } from '../../../../../hooks/store/useStore';
import { userJoinSlice } from '../../../../../store/userJoinSlice';
import { JoinProcessPageWrapper } from '../JoinProcessPageWrapper';

export const JoinProcessBusinessTypePage = () => {
  const navigate = useNavigate();

  const [businessType, setBusinessType] = useState<string>();
  const [isSlideModalOpen, setIsSlideModalOpen] = useState<boolean>(false);
  const [isPopupModalOpen, setIsPopupModalOpen] = useState<boolean>(false);

  const dispatch = useAppDispatch();
  const userJoinActions = userJoinSlice.actions;

  const confirmSlideModal = () => {
    setIsSlideModalOpen(false);
    setIsPopupModalOpen(true);
  };

  const closeSlideModal = () => {
    setIsSlideModalOpen(false);
  };

  const confirmPopupModal = (businessTypeEtc: string) => {
    dispatch(userJoinActions.changeBusinessTypeEtc(businessTypeEtc));
    setIsPopupModalOpen(false);
  };

  return (
    <>
      <JoinProcessPageWrapper
        headerTitle={'사업 형태를 알려주세요'}
        canConfirm={businessType !== undefined}
        confirmHandler={() => {
          dispatch(userJoinActions.changeBusinessType(businessType!));
          navigate('/join-process/reason', { replace: true });
        }}
      >
        <SurveyForm>
          <SurveyInputHeader inputTitle={'사업 형태'} isRequired />

          <SurveyInputContainer gridColumns={1}>
            {joinProcessConstants.businessType.values.map((value, index) => (
              <RadioCard
                key={value}
                title={value}
                label={
                  joinProcessConstants.businessType.labels && joinProcessConstants.businessType.labels.length > 0
                    ? joinProcessConstants.businessType.labels[index]
                    : undefined
                }
                onClick={() => {
                  setBusinessType(value);

                  if (value === '기타') {
                    setIsSlideModalOpen(true);
                  }
                }}
                isActive={businessType === value}
              />
            ))}
          </SurveyInputContainer>
        </SurveyForm>
      </JoinProcessPageWrapper>

      <SlideConfirmModal
        isShow={isSlideModalOpen}
        height={189}
        description={'사업 형태를 간략하게 적어주실 수 있나요?'}
        confirmButton={{ handleClick: confirmSlideModal, text: '네, 그렇게 할게요.' }}
        closeButton={{ handleClick: closeSlideModal, text: '닫기' }}
      />

      <PopupTextInputModal
        isShow={isPopupModalOpen}
        title={'간략하게 적어주세요 🙂'}
        placeholder={'예) 농기계 제조업'}
        confirmText={'완료'}
        confirmHandler={(value: string) => {
          confirmPopupModal(value);
        }}
      />
    </>
  );
};
